<ng-template #content let-modal>
  <div class="modal-header modal-custom__header modal__itineraries-header">
    <h4 class="modal-title" id="modal-basic-title">
      <i class="icon-pin"></i> Dove vuoi andare?
    </h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss()"
    ></button>
  </div>
  <div class="modal-body modal-custom__body modal__itineraries-body">
    <div class="destinations-itineraries__container">
      <div
        class="destinations-itineraries__column"
        (click)="selectItinerary(itinerary?.Id)"
        *ngFor="
          let itinerary of (cruisePrefetch$ | async)?.itineraries
            | getDataFromMapping : 'itinerary'
            | removeItinerary
            | async
            | ngSelectSortBy : 'Name'
        "
      >
        <a
          class="destinations-itineraries__element"
          [class.active]="itinerary?.Id === selectedItineraryInner"
        >
          {{ itinerary?.Name }}
        </a>
      </div>
    </div>
  </div>
  <div
    class="modal-footer modal-custom__footer modal__itineraries-footer itineraries-thumbnail__bottom"
  ></div>
</ng-template>

<div class="form-group-custom">
  <label for="inputItinerary" class="input-group-zeus__label">Itinerario</label>
  <div
    class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent"
    id="cruiseItinerary-dropdown"
  >
    <input
      type="text"
      class="form-control-custom"
      id="inputItinerary"
      [placeholder]="
        selectedItineraryInner
          ? (selectedItineraryInner | getDataFromMapping : 'itinerary' | async)
              ?.Name
          : 'Seleziona l\'itinerario...'
      "
      aria-label="Itinerario"
      aria-describedby="basic-addon3"
      (click)="open(content)"
      readonly
    />
    <div
      class="input-group-custom__prepend input-group-custom__prepend--transparent"
    >
      <span
        class="input-group-custom__icon input-group-custom__icon--transparent"
        id="basic-addon3"
        ><i class="icon-pin"></i
      ></span>
    </div>
    <div
      class="input-group-custom__append input-group-custom__append--transparent close-element"
      *ngIf="selectedItineraryInner"
    >
      <span
        (click)="deselectItineraryCB()"
        class="input-group-custom__icon input-group-custom__icon--transparent"
        ><i class="g-icon-close"></i
      ></span>
    </div>
  </div>
</div>
